import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/ui/use-toast';

export const usePasswordVerification = () => {
  const [password, setPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const verifyPassword = async (): Promise<boolean> => {
    if (!password.trim()) {
      toast.error("Please enter your password.");
      return false;
    }

    setIsVerifying(true);
    try {
      // Get current user email
      const { data: { user } } = await supabase.auth.getUser();
      if (!user?.email) {
        toast.error("Unable to verify user. Please try logging in again.");
        return false;
      }

      // Verify password by attempting to sign in
      const { error } = await supabase.auth.signInWithPassword({
        email: user.email,
        password: password
      });

      if (error) {
        toast.error("Incorrect password. Please try again.");
        setPassword("");
        return false;
      }

      setIsVerified(true);
      toast.success("Password verified.");
      return true;
    } catch (error) {
      console.error('Error verifying password:', error);
      toast.error("Failed to verify password. Please try again.");
      setPassword("");
      return false;
    } finally {
      setIsVerifying(false);
    }
  };

  const resetVerification = () => {
    setPassword("");
    setIsVerified(false);
    setIsVerifying(false);
  };

  return {
    password,
    setPassword,
    isVerifying,
    isVerified,
    verifyPassword,
    resetVerification,
  };
};